// extracted by mini-css-extract-plugin
export default {"modalbody":"Modal_modalbody__3+c17","close-btn":"Modal_close-btn__HPDzA"};